<template>
  <div class>
    <div class="footer my-10 container flex flex-col">
      <h2 class="text-center vermelhowdc montserrat font-bold text-lg md:text-3xl my-5 md:my-auto">{{atual[pagina].footer}}</h2>
      <div class="flex md:my-10 mx-auto text-center">
        <button class="btn-back roboto md:text-lg p-2 md:p-4 mx-2 md:mx-5" @click="alterpage(pagina)" v-if="pagina > 0">VOLTAR</button>
        <button class="btn-next roboto md:text-lg p-2 md:p-4 mx-2 md:mx-5 text-white" @click="alterpage(pagina+2)" v-if="atual[pagina+1]">AVANÇAR</button>
        <button class="btn-next roboto md:text-lg p-2 md:p-4 mx-2 md:mx-5 text-white finalizar" v-else>FINALIZAR</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text_color: {
      type: String,
      default: "#001C32",
    },
    atual:{
      type:Array,
    },
    pagina:{
      type:Number,
    },
  },
  methods:{
    alterpage(page){
      this.$emit('mudadepagina',page);
    }
  }
};
</script>

<style scoped>
  @media(max-width: 600px){
    .finalizar{
      font-size: 12px !important;
    }
  }
</style>
